import { render, staticRenderFns } from "./CRUDCandidatos.vue?vue&type=template&id=58f1ea4c&scoped=true&"
import script from "./CRUDCandidatos.vue?vue&type=script&lang=js&"
export * from "./CRUDCandidatos.vue?vue&type=script&lang=js&"
import style0 from "./CRUDCandidatos.vue?vue&type=style&index=0&id=58f1ea4c&prod&scoped=true&lang=css&"
import style1 from "./CRUDCandidatos.vue?vue&type=style&index=1&id=58f1ea4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1ea4c",
  null
  
)

export default component.exports